// material-ui
import { useTheme } from '@mui/material/styles';
import { ReactComponent as LogoIcon } from '../../../assets/images/icons/bgd_logo.svg';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    return <LogoIcon width={'100%'} />;
};

export default Logo;
